/**
 * JET Atolye Search - Faz C
 * ==========================
 * Fuse.js wrapper. Sticker/Pattern/Template panel'leri ortak `JetSearch.create()`
 * cagirir, manifest entry'lerini fuzzy filter eder.
 *
 * Turkce karakter normalize: `getFn` ile her arama input'u + key value
 * lowercase + diacritic-strip uygulanir (s/S/i/I/g/G/u/U/o/O/c/C).
 * Threshold 0.35 (loose-ish; "kalp" -> "kalpler", "alinti" -> "alintilar").
 */
(function () {
  'use strict';

  if (window.JetSearch) return;

  // Turkce + temel diacritic strip. Fuse.js getFn'inin dondurdugu degerlere
  // ve user input'a uygulanir. Asci-fold sade yaklasim.
  var TR_MAP = {
    'i': 'i', 'I': 'i', 'i': 'i', 'I': 'i',
    'g': 'g', 'G': 'g',
    'u': 'u', 'U': 'u',
    's': 's', 'S': 's',
    'o': 'o', 'O': 'o',
    'c': 'c', 'C': 'c',
  };

  function normalize(s) {
    if (s == null) return '';
    var raw = String(s);
    var out = '';
    for (var i = 0; i < raw.length; i++) {
      out += TR_MAP[raw[i]] || raw[i];
    }
    return out.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function create(items, opts) {
    opts = opts || {};
    if (typeof Fuse === 'undefined') {
      console.warn('[JetSearch] Fuse.js yuklenmedi');
      return { search: function (q) { return items; } };
    }
    var keys = opts.keys || ['label', 'name', 'tags', 'category', 'id'];
    var fuse = new Fuse(items, {
      keys: keys,
      threshold: opts.threshold == null ? 0.35 : opts.threshold,
      ignoreLocation: true,
      minMatchCharLength: 1,
      includeScore: false,
      // getFn: arama hem key value hem input icin normalize aciliyor
      getFn: function (obj, path) {
        var v = Fuse.config.getFn(obj, path);
        if (Array.isArray(v)) return v.map(normalize);
        return normalize(v);
      },
    });
    return {
      search: function (q) {
        var query = normalize(q || '');
        if (!query) return items.slice();
        return fuse.search(query).map(function (r) { return r.item; });
      },
      _fuse: fuse,
    };
  }

  window.JetSearch = { create: create, normalize: normalize };
})();
